import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IWorkspacePermissionRequestResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IWorkspacePermissionRequestResponseInstance'
import {
  IWorkspacePermissionRequestRequestedForPayload,
  IWorkspacePermissionRequestRequestedForResponseEntity,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IWorkspacePermissionRequestRequestedForResponseEntity'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'
import {mapAutomationAppResponseInstance} from '@toolify/client/src/modules/api/singletons/mapAutomationAppResponseInstance'

function mapRequestedFor(
  requestedFor: IToJson<IWorkspacePermissionRequestRequestedForResponseEntity> | null | undefined,
): IWorkspacePermissionRequestRequestedForResponseEntity | null {
  if(!requestedFor) {
    return null
  }
  const payload = requestedFor.payload
  let mappedPayload: IWorkspacePermissionRequestRequestedForPayload | null = null
  if(payload) {
    mappedPayload = {
      color: payload.color ?? null,
      iconNameType: payload.iconNameType ?? null,
      app: payload.app ? mapAutomationAppResponseInstance(payload.app) : null,
      entity: payload.entity ? mapResponseEntity(payload.entity) : null,
    }
  }
  return {
    entityType: requestedFor.entityType,
    entityId: requestedFor.entityId,
    name: requestedFor.name ?? '',
    payload: mappedPayload,
  }
}

export function mapWorkspacePermissionRequestResponseInstance(
  request: IToJson<IWorkspacePermissionRequestResponseInstance>,
): IWorkspacePermissionRequestResponseInstance {
  return {
    ...request,
    createdAt: new Date(request.createdAt),
    reviewedAt: request.reviewedAt ? new Date(request.reviewedAt) : null,
    requestedFor: mapRequestedFor(request.requestedFor),
    requestedByEntity: request.requestedByEntity
      ? mapResponseEntity(request.requestedByEntity)
      : null,
    reviewedByEntity: request.reviewedByEntity
      ? mapResponseEntity(request.reviewedByEntity)
      : null,
  }
}
